import Modal from '../Modal';
import ModalTitle from '../ModalTitle';

const ContactEmailExistsWarningModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      className="spo-o-contact-email-exists-warning-modal"
      title={<ModalTitle hasError title="Opgelet!" />}
      isOpen={isOpen}
      onClose={onClose}
      disableConfirm
      disableCancel
    >
      <p>
        Er bestaat reeds een contact met dit e-mailadres, gelieve contact op te nemen met ons{' '}
        <a href="mailto:schoolontwikkeling@antwerpen.be">{'(schoolontwikkeling@antwerpen.be)'}</a> en te beschrijven
        welk contact je probeert aan te maken.
      </p>
    </Modal>
  );
};

export default ContactEmailExistsWarningModal;
